import React from 'react';
import './Banner.css';
//import beachImage from '../images/beach-sean-oulashin.jpg';

const beachImage = '/images/beach-sean-oulashin.jpg';


const Banner: React.FC = () => {
    return (
        <div className="banner" style={{ backgroundImage: `url(${beachImage})` }}>
            <div className="banner-overlay">
                <h1>No Consumer Left Behind</h1>
                <p><strong><u>Let us fight for you!</u></strong></p>
            </div>
        </div>
    );
};

export default Banner;